import React, {useEffect, useState} from "react";
import {useTheme} from "@mui/material/styles";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import {useNavigate} from "react-router-dom";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import MDInput from "components/MDInput";
import {
  Alert,
  AppBar,
  Card,
  FormControlLabel,
  Snackbar,
  InputLabel,
  Typography,
  MenuItem,
  Select,
  FormControl
} from "@mui/material";
import MDButton from "components/MDButton";
import {PATCH} from "APIclient";
import {useLocation} from "react-router-dom";
import {DataGrid} from "@mui/x-data-grid";
import {column} from "stylis";
import {useMaterialUIController} from "context";
import {DatePicker, LocalizationProvider} from "@mui/x-date-pickers";
import {DemoContainer} from "@mui/x-date-pickers/internals/demo";
import dayjs from "dayjs";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import {GET} from "APIclient";
import {POST} from "APIclient";
import properties from "constants/ApplicationConstants";
import {formatDesignation} from "constants/ApplicationConstants";
import {formatDate} from "constants/ApplicationConstants";

function ApplyResignation(noGutter) {
  const [controller] = useMaterialUIController();
  const {darkMode} = controller;
  const location = useLocation();
  const [usersState, setUsersState] = useState(location.state);
  const theme = useTheme();
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const [snackbar, setSnackbar] = useState(null);
  const [snakColor, setSnakColor] = useState("");
  const [snakMessage, setSnakMessage] = useState("");
  const viewUrl = `admin/get-salaries/${usersState}`;
  const [details, setDetails] = useState([]);
  const [formData, setFormData] = useState({
    applyDate: dayjs(null),
    reason: ""
  });

  const [errors, setErrors] = useState({
    applyDate: "",
    reason: ""
  });

  const validateField = (name, value) => {
    let error = "";

    if (name === "reason") {
      if (!value || value.trim() === "") {
        error = "Reason is required";
      } else if (!/^[a-zA-Z\s]+$/.test(value)) {
        error = "Reason must contain only letters and spaces";
      }
    }

    if (name === "applyDate") {
      if (!value) {
        error = "Resignation date is required";
      } else {
        const selectedDate = dayjs(value);
        const today = dayjs().startOf("day");
        if (selectedDate.isBefore(today)) {
          error = "Resignation date cannot be in the past";
        }
      }
    }
    return error;
  };

  const handleCloseSnackbar = () => setSnackbar(null);

  React.useEffect(() => {
    const view = async () => {
      try {
        const response = await GET(viewUrl);
        const view = response?.data?.data;
        setDetails(view);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    view();
  }, [viewUrl]);

  const formattedDesignation = formatDesignation(details?.designation ?? "-");

  const handleClose = () => {
    setOpen(false);
  };

  const handleChange = event => {
    const {name, value} = event.target;

    const error = validateField(name, value);

    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));

    setErrors(prevErrors => ({
      ...prevErrors,
      [name]: error
    }));
  };

  const handleDateChange = (date, field) => {
    const validDate = date ? dayjs(date) : null;
    const formattedDate = validDate?.isValid() ? validDate.format("YYYY-MM-DD") : null;

    const error = validateField(field, formattedDate);

    setFormData(prev => ({
      ...prev,
      [field]: formattedDate
    }));

    setErrors(prevErrors => ({
      ...prevErrors,
      [field]: error
    }));
  };

  const handleSubmit = async () => {
    const applyDateError = validateField("applyDate", formData.applyDate);
    const reasonError = validateField("reason", formData.reason);

    const newErrors = {
      applyDate: applyDateError,
      reason: reasonError
    };

    setErrors(newErrors);

    const dt = {
      empId: String(usersState),
      applyDate: formData.applyDate,
      reason: formData.reason
    };

    const url = `employee/applyResignation`;

    try {
      const response = await POST(url, dt);
      if (response?.status === 200) {
        setSnakColor("success");
        setSnakMessage(response?.data?.message);
        setOpen(true);
        // Optionally navigate to another page after successful update
        // navigate('/some/other/page');
      } else {
        setSnakColor("error");
        setSnakMessage("Failed to update");
        setOpen(true);
      }
    } catch (error) {
      console.error("Error updating permissions:", error);
      setSnakColor("error");
      setSnakMessage("Error updating permissions");
      setOpen(true);
    }
  };

  const isSaveButtonEnabled = () => {
    const applyDateError = validateField("applyDate", formData.applyDate);
    const reasonError = validateField("reason", formData.reason);
    return !applyDateError && !reasonError && formData.applyDate && formData.reason.trim();
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox container>
        <AppBar position="static">
          <Card>
            <MDBox
              pt={2}
              mb={0}
              pb={4}
              px={4}
              sx={{borderRadius: "5px", border: "1px solid #D3D3D3"}}
            >
              <Typography
                sx={{
                  color: "textPrimary",
                  fontFamily: properties.fontFamily,
                  fontSize: "16px",
                  fontWeight: "bold"
                }}
              >
                {" "}
                Apply Resignation
              </Typography>

              {/* <MDBox pt={1} pb={0} px={2}> */}
              <MDBox pt={1} px={2} mb={2}></MDBox>
              <MDBox
                component="li"
                display="flex"
                justifyContent="space-between"
                alignItems="flex-start"
                bgColor={darkMode ? "transparent" : "grey-100"}
                borderRadius="lg"
                p={2}
                mt={1}
              >
                <MDBox width="100%" display="flex" flexDirection="column">
                  <MDTypography
                    variant="h6"
                    fontWeight="medium"
                    pb={2}
                    sx={{fontFamily: properties.fontFamily}}
                  >
                    Employee Details
                  </MDTypography>
                  <MDBox
                    display="grid"
                    gridTemplateColumns={{xs: "1fr", sm: "repeat(3, 1fr)"}}
                    gap={2}
                    mb={2}
                  >
                    <MDBox display="flex" alignItems="center">
                      <MDTypography
                        variant="caption"
                        color="text"
                        fontFamily={properties.fontFamily}
                        sx={{fontSize: "12px", fontWeight: "500", minWidth: "120px"}}
                      >
                        Employee ID:
                      </MDTypography>
                      <MDTypography
                        variant="caption"
                        fontFamily={properties.fontFamily}
                        sx={{fontSize: "12px", fontWeight: "600", minWidth: "120px"}}
                      >
                        {details ? details.empId : "-"}
                      </MDTypography>
                    </MDBox>
                    <MDBox display="flex" alignItems="center">
                      <MDTypography
                        variant="caption"
                        color="text"
                        fontFamily={properties.fontFamily}
                        sx={{fontSize: "12px", fontWeight: "500", minWidth: "120px"}}
                      >
                        Joining Date:
                      </MDTypography>
                      <MDTypography
                        variant="caption"
                        fontFamily={properties.fontFamily}
                        sx={{fontSize: "12px", fontWeight: "600", minWidth: "120px"}}
                      >
                        {details ? formatDate(details.joinDate) : "-"}
                      </MDTypography>
                    </MDBox>
                    <MDBox display="flex" alignItems="center">
                      <MDTypography
                        variant="caption"
                        color="text"
                        fontFamily={properties.fontFamily}
                        sx={{fontSize: "12px", fontWeight: "500", minWidth: "120px"}}
                      >
                        Designation:
                      </MDTypography>
                      <MDTypography
                        variant="caption"
                        fontFamily={properties.fontFamily}
                        sx={{fontSize: "12px", fontWeight: "600", minWidth: "120px"}}
                      >
                        {formattedDesignation}
                      </MDTypography>
                    </MDBox>
                  </MDBox>
                  <MDBox
                    display="grid"
                    gridTemplateColumns={{xs: "1fr", sm: "repeat(3, 1fr)"}}
                    gap={2}
                    mb={2}
                  >
                    <MDBox display="flex" alignItems="center">
                      <MDTypography
                        variant="caption"
                        color="text"
                        fontFamily={properties.fontFamily}
                        sx={{fontSize: "12px", fontWeight: "500", minWidth: "120px"}}
                      >
                        First Name:
                      </MDTypography>
                      <MDTypography
                        variant="caption"
                        fontFamily={properties.fontFamily}
                        sx={{fontSize: "12px", fontWeight: "600", minWidth: "120px"}}
                      >
                        {details ? details.firstName : "-"}
                      </MDTypography>
                    </MDBox>
                    <MDBox display="flex" alignItems="center">
                      <MDTypography
                        variant="caption"
                        color="text"
                        fontFamily={properties.fontFamily}
                        sx={{fontSize: "12px", fontWeight: "500", minWidth: "120px"}}
                      >
                        Middle Name:
                      </MDTypography>
                      <MDTypography
                        variant="caption"
                        fontFamily={properties.fontFamily}
                        sx={{fontSize: "12px", fontWeight: "600", minWidth: "120px"}}
                      >
                        {details ? details?.middleName : " - "}
                      </MDTypography>
                    </MDBox>
                    <MDBox display="flex" alignItems="center">
                      <MDTypography
                        variant="caption"
                        color="text"
                        fontFamily={properties.fontFamily}
                        sx={{fontSize: "12px", fontWeight: "500", minWidth: "120px"}}
                      >
                        Last Name:
                      </MDTypography>
                      <MDTypography
                        variant="caption"
                        fontFamily={properties.fontFamily}
                        sx={{fontSize: "12px", fontWeight: "600", minWidth: "120px"}}
                      >
                        {details ? details.lastName : "-"}
                      </MDTypography>
                    </MDBox>
                  </MDBox>
                  <MDBox
                    display="grid"
                    gridTemplateColumns={{xs: "1fr", sm: "repeat(3, 1fr)"}}
                    gap={2}
                    mb={2}
                  >
                    <MDBox display="flex" alignItems="center">
                      <MDTypography
                        variant="caption"
                        color="text"
                        fontFamily={properties.fontFamily}
                        sx={{fontSize: "12px", fontWeight: "500", minWidth: "120px"}}
                      >
                        Personal Email ID:
                      </MDTypography>
                      <MDTypography
                        variant="caption"
                        fontFamily={properties.fontFamily}
                        sx={{fontSize: "12px", fontWeight: "600", minWidth: "120px"}}
                      >
                        {details ? details.emailAddress : "-"}
                      </MDTypography>
                    </MDBox>
                    <MDBox display="flex" alignItems="center">
                      <MDTypography
                        variant="caption"
                        color="text"
                        fontFamily={properties.fontFamily}
                        sx={{fontSize: "12px", fontWeight: "500", minWidth: "120px"}}
                      >
                        Official Email ID:
                      </MDTypography>
                      <MDTypography
                        variant="caption"
                        fontFamily={properties.fontFamily}
                        sx={{fontSize: "12px", fontWeight: "600", minWidth: "120px"}}
                      >
                        {details ? details.officialEmailAddress : "-"}
                      </MDTypography>
                    </MDBox>
                    <MDBox display="flex" alignItems="center">
                      <MDTypography
                        variant="caption"
                        color="text"
                        fontFamily={properties.fontFamily}
                        sx={{fontSize: "12px", fontWeight: "500", minWidth: "120px"}}
                      >
                        Mobile:
                      </MDTypography>
                      <MDTypography
                        variant="caption"
                        fontFamily={properties.fontFamily}
                        sx={{fontSize: "12px", fontWeight: "600", minWidth: "120px"}}
                      >
                        {details ? details.mobileNo : "-"}
                      </MDTypography>
                    </MDBox>
                  </MDBox>
                  <MDBox
                    display="grid"
                    gridTemplateColumns={{xs: "1fr", sm: "repeat(3, 1fr)"}}
                    gap={2}
                    mb={2}
                  >
                    <MDBox display="flex" alignItems="center">
                      <MDTypography
                        variant="caption"
                        color="text"
                        fontFamily={properties.fontFamily}
                        sx={{fontSize: "12px", fontWeight: "500", minWidth: "120px"}}
                      >
                        Current CTC:
                      </MDTypography>
                      <MDTypography
                        variant="caption"
                        fontFamily={properties.fontFamily}
                        sx={{fontSize: "12px", fontWeight: "600", minWidth: "120px"}}
                      >
                        {details ? details.salary : "-"}
                      </MDTypography>
                    </MDBox>
                    <MDBox display="flex" alignItems="center">
                      <MDTypography
                        variant="caption"
                        color="text"
                        fontFamily={properties.fontFamily}
                        sx={{fontSize: "12px", fontWeight: "500", minWidth: "120px"}}
                      >
                        Applicable From:
                      </MDTypography>
                      <MDTypography
                        variant="caption"
                        fontFamily={properties.fontFamily}
                        sx={{fontSize: "12px", fontWeight: "600", minWidth: "120px"}}
                      >
                        {details ? formatDate(details.fromDate) : "-"}
                      </MDTypography>
                    </MDBox>
                  </MDBox>
                </MDBox>
              </MDBox>

              <MDBox pt={2} mb={0} pb={2} px={1}>
                <InputLabel
                  sx={{
                    fontWeight: "bold",
                    paddingBottom: "20px",
                    fontFamily: properties.fontFamily
                  }}
                >
                  Apply For Resignation
                </InputLabel>
                {/* <Typography variant="h6" color="textPrimary">Reporting Details</Typography> */}
                <MDBox pt={2}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DemoContainer components={["DatePicker"]}>
                      <DatePicker
                        format="DD/MM/YYYY"
                        sx={{m: 1, width: "30ch", paddingBottom: "20"}}
                        size="small"
                        name="applyDate"
                        label={
                          <span>
                            Resignation Date <span style={{color: properties.colors.Red}}>*</span>
                          </span>
                        }
                        value={formData ? dayjs(formData.applyDate) : null}
                        onChange={date => handleDateChange(date, "applyDate")}
                        slotProps={{
                          textField: {
                            error: Boolean(errors.applyDate),
                            helperText: errors.applyDate
                          }
                        }}
                        // disabled={formData?.probationApplicable == '0'}
                      />
                    </DemoContainer>
                  </LocalizationProvider>
                </MDBox>
                <MDBox pt={2}>
                  <MDInput
                    sx={{m: 1, width: "30ch"}}
                    multiline
                    maxRows={4}
                    type="text"
                    name="reason"
                    label={
                      <span>
                        Reason <span style={{color: properties.colors.Red}}>*</span>
                      </span>
                    }
                    value={formData?.reason}
                    onChange={e => handleChange(e)}
                    variant="standard"
                    error={Boolean(errors.reason)}
                    helperText={errors.reason}
                  />
                </MDBox>
              </MDBox>

              <MDBox mt={1} mb={2} sx={{display: "flex", justifyContent: "flex-end"}}>
                <MDBox sx={{display: "flex", gap: 2}}>
                  <MDButton
                    variant="gradient"
                    color="warning"
                    sx={{width: "20ch", fontFamily: properties.fontFamily}}
                    onClick={() => navigate(-1)}
                  >
                    Back
                  </MDButton>

                  <MDButton
                    variant="gradient"
                    color="#fff"
                    sx={{
                      marginRight: "3px",
                      width: "20ch",
                      background: properties.colors.bgcolorbluethem,
                      fontFamily: properties.fontFamily
                    }}
                    onClick={() => handleSubmit()}
                    disabled={!isSaveButtonEnabled()}
                  >
                    Save
                  </MDButton>
                </MDBox>
              </MDBox>

              <Snackbar
                open={open}
                anchorOrigin={{vertical: "top", horizontal: "right"}}
                autoHideDuration={1200}
                onClose={handleClose}
              >
                <Alert
                  onClose={handleClose}
                  severity={snakColor === "success" ? "success" : "error"}
                  variant="filled"
                  sx={{width: "100%"}}
                >
                  {snakMessage}
                </Alert>
              </Snackbar>
            </MDBox>
          </Card>
        </AppBar>
      </MDBox>
    </DashboardLayout>
  );
}

export default ApplyResignation;
